import { Box, SxProps, TextField } from '@mui/material'
import { FC } from 'react'
import { allCountryNames, getCountryAbbrByName } from '../../utils/countries'

import * as S from './CountrySelect.styles'

interface ICountrySelectProps {
  value?: string | null
  onChange: (newValue: string) => void
  onFocus?: (e: React.FocusEvent<HTMLDivElement, Element>) => void
  onBlur?: (e: React.FocusEvent<HTMLInputElement, Element>) => void
  size?: 'small' | 'medium'
  label?: string
  sx?: SxProps
}

const CountrySelect: FC<ICountrySelectProps> = ({
  value,
  onChange,
  onFocus,
  onBlur,
  label = 'Country',
  size,
  sx,
}) => {
  return (
    <S.Autocomplete
      id='country'
      fullWidth
      size={size}
      options={allCountryNames}
      sx={{
        ...sx,
      }}
      value={value}
      onChange={(_, rawValue) => {
        const newValue = rawValue as string
        onChange(newValue)
      }}
      onFocus={(e: React.FocusEvent<HTMLDivElement, Element>) => {
        onFocus?.(e)
      }}
      onBlur={(e: React.FocusEvent<HTMLInputElement, Element>) => {
        onBlur?.(e)
      }}
      autoHighlight
      renderOption={(props, rawOption) => {
        const option = rawOption as string
        const countryAbbr = getCountryAbbrByName(option)?.toLowerCase()

        return (
          <Box component='li' sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
            {countryAbbr && (
              <img
                loading='lazy'
                width='20'
                src={`https://flagcdn.com/w20/${countryAbbr}.png`}
                srcSet={`https://flagcdn.com/w40/${countryAbbr}.png 2x`}
                alt=''
              />
            )}
            {option}
          </Box>
        )
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          label={label}
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
        />
      )}
    />
  )
}

export default CountrySelect
